<template>
  <div id="main-content">
    <a-form layout="inline" style="background: #ffffff;padding: 10px;margin-bottom: 10px;border-radius: 10px;">
      <a-form-item>
        <a-select style="width: 200px" v-model="channel" allowClear @change="changeChannel"
                  optionFilterProp="label" placeholder="请选择渠道">
          <a-select-option v-for="channelItem in $store.state.SpendChannel"
                           :value="channelItem.value"
                           :label="channelItem.name"
                           :key="channelItem.value">
            {{channelItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select v-model="advertiser_id" style="width: 200px"
                  show-search allowClear @change="init_data"
                  optionFilterProp="label" placeholder="请选择账户">
          <a-select-option :value="advertiserItem.advertiser_id"
                           :key="advertiserItem.advertiser_id"
                           :label="advertiserItem.name+advertiserItem.advertiser_id"
                           v-for="advertiserItem in advertiserList">
            {{advertiserItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-select style="width: 200px" v-model="country" allowClear @change="init_data"
                  mode="multiple" :maxTagCount="1" optionFilterProp="label" placeholder="请选择国家">
          <a-select-option :key="countryItem.value" :value="countryItem.value"
                           :label="countryItem.name"
                           v-for="countryItem in $store.state.Country">
            {{countryItem.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-range-picker v-model="date"
                        @change="init_data"
                        valueFormat="YYYY-MM-DD"
                        style="width: 240px;"  />
      </a-form-item>
      <a-form-item>
         <a-radio-group button-style="solid" v-model="cate" @change="init_data">
          <a-radio-button value="">
            全部
          </a-radio-button>
          <a-radio-button value="game">
            游戏
          </a-radio-button>
          <a-radio-button value="ai">
            AI
          </a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item style="float: right;margin: 0">
        <a-button type="danger" ghost @click="()=>{showCloseStatus=true}">封禁</a-button>
      </a-form-item>
      <a-form-item style="float: right;margin-right: 5px;">
        <a-button type="primary" ghost @click="download">下载</a-button>
      </a-form-item>
      <a-form-item style="float: right;margin-right: 5px;">
        <a-button type="primary" ghost @click="()=>{showConfigStatus=true}">新增配置</a-button>
      </a-form-item>
    </a-form>
    <a-table :columns="getTableColumns" id="show-table"
             style="flex: 1;overflow-y: hidden;background: #ffffff"
             :scroll="{ x: '500px',y: _get_table_scroll({id:'show-table'}) }" :data-source="tableData"
             :rowKey="item=>item.date" :loading="tableLoad"
             bordered :pagination="false">
      <template slot="date" slot-scope="text,recode">
        {{date[0]}} - {{date[1]}}
      </template>
      <template slot="advertiser_name" slot-scope="text,recode">
        {{recode.advertiser_name}}({{recode.advertiser}})
      </template>
    </a-table>
    <ConfigPanel :show-panel="showConfigStatus" @close-dialog="()=>{showConfigStatus=false;init_data()}"></ConfigPanel>
    <ClosePanel :show-panel="showCloseStatus" @close-dialog="()=>{showCloseStatus=false;init_data()}"></ClosePanel>
  </div>
</template>

<script>
import ConfigPanel from "./ConfigPanel";
import ClosePanel from "./ClosePanel";
import {GetAccountAdvertiser, GetSpendRebate} from "../../../api/v1/spend_rebate_api";
export default {
  name: "Index",
  components: {ClosePanel, ConfigPanel},
  data(){
    return {
      channel:[],
      date:[],
      country:[],
      advertiser_id:'',
      cate:'',
      tableLoad:false,
      tableData:[],
      showConfigStatus:false,
      showCloseStatus:false,
      advertiserList:[],
    }
  },
  computed:{
    getTableColumns(){
      let _table_columns = [
        { title: '日期', dataIndex: 'date',scopedSlots: { customRender: 'date' },align:'center'},
        { title: '账户', dataIndex: 'advertiser_name',scopedSlots: { customRender: 'advertiser_name' },align:'center'},
        { title: '国家', dataIndex: 'country',align:'center'},
        { title: '有效消耗', dataIndex: 'spend', scopedSlots: { customRender: 'spend' },align:'center'},
        { title: '返点比例 %', dataIndex: 'ratio', scopedSlots: { customRender: 'ratio' },align:'center'},
        { title: '返点佣金', dataIndex: 'rebate', width:'200px',align:'center'},
      ]
      return _table_columns
    }
  },
  mounted() {
    this.init_data()
  },
  methods:{
    download(){
      let _name = "返点账户明细"+this.date[0]+"到"+this.date[1]
      var _data_list = this.tableData
      var _data_field = this.getTableColumns
      this._export_cvs(_data_list,_data_field,_name)
    },
    changeChannel(){
      GetAccountAdvertiser({
        channel:this.channel,
        account:''
      }).then(resp => {
        if (resp.code == 200){
          this.advertiser_id = ''
          this.advertiserList = resp.data.advertiser_list
        }
      })
      this.init_data()
    },
    init_data(){
      this.tableLoad = true
      GetSpendRebate({
        channel:this.channel,
        advertiser:this.advertiser_id,
        cate:this.cate,
        country:this.country,
        date:this.date
      }).then(resp => {
        this.tableLoad = false
        if (resp.code===200){
          this.tableData = resp.data.list
          this.date = resp.data.date
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Spend/Rebate/Index.vue